import {Route, Routes} from "react-router-dom";
import * as React from "react";
import {BminingSaasHomeComponent} from "../components/BminingSaaS/BminingSaasHomeComponent";

export const DemoRoutes = () => {
    return <Routes>
        <Route path='/' element={<BminingSaasHomeComponent/>}/>
    </Routes>
}